import React, { useState } from "react";
import './Process.css'
import step1Icon from '../../utils/assets/images/step1-icon.svg'
import step2Icon from '../../utils/assets/images/step2-icon.svg'
import step3Icon from '../../utils/assets/images/step3-icon.svg'
import step4Icon from '../../utils/assets/images/step4-icon.svg'
import step5Icon from '../../utils/assets/images/step5-icon.svg'
import step6Icon from '../../utils/assets/images/step6-icon.svg'
import step7Icon from '../../utils/assets/images/step7-icon.svg'
import step8Icon from '../../utils/assets/images/step8-icon.svg'
import step9Icon from '../../utils/assets/images/step9-icon.svg'
const ProcessSummary = () => {
    const processSumary = [
        {
            id: 1,
            icon: step1Icon,
            stepColor: "#586C48",
            title: "Initial Proposal and Project Datasheet",
            description: "Developer downloads the Project Datasheet from the website and fills it with the project's details. Subsequently, they will submit both the completed Project Datasheet and an Initial Proposal. This proposal introduces the consortium, outlines its capabilities, and provides information about the envisioned projects along with their respective phases"
        },
        {
            id: 2,
            icon: step2Icon,
            stepColor: "#57753F",
            title: "Sponsors Assessment and Feedback",
            description: "Government Sponsors will assess the submitted Project Datasheet and Initial Proposal and will provide feedback through email or portal.Once agreed, the Developer receives the MoU template"
        },
        {
            id: 3,
            icon:step3Icon,
            stepColor: "#567E36",
            title: "MoU Signature",
            description: "Government Sponsors sign a Memorandum of Understanding (MoU) with the Developer which is set to outline:",
            listContent: ['The roles and responsibilities of each party', 'The Project’s capacities', 'Any special arrangement relating to power or utilities for the project']
        },
        {
            id: 4,
            icon:step4Icon,
            stepColor: "#55872D",
            title: "Land Allocation",
            description: "According to the MoU, NREA in coordination with EETC will allocate land coordinates for the developer matching the agreed form Project Data Sheet’s targeted renewable energy capacity"
        },
        {
            id: 5,
            icon: step5Icon,
            stepColor: "#549024",
            title: "Preliminary Studies",
            description: "Developer conducts Preliminary Studies and submits them to Government Sponsors for review and acceptance via email or portal.These include; a preliminary feasibility study, preliminary business case/technical study,preliminary master schedule for the project execution, update and/or comfort letters on offtake and financing arrangements (if available)"
        },
        {
            id: 6,
            icon:step6Icon,
            stepColor: "#539A1B",
            title: "Framework Agreement Signature",
            description: 'A Binding Framework Agreement is signed by the parties which outlines:',
            listContent: ['The contractual relationship amongst all parties to the MoU', ' A significant commitment from the government on the land allocation for the entire project to enable the Lead Developer to conduct their feasibility studies with certainty', 'Commitment from the Lead Developer on a detailed project implementation schedule']

        },
        {
            id: 7,
            icon: step7Icon,
            stepColor: "#52A312",
            title: "Pre and Final Feasibility Studies",
            description: "Feasibility Studies are carried out by the Developer and submitted to the Government Sponsors through email or portal, including:",
            listContent: ['Technical Study', 'Financial Model', 'Master Schedule for the Project Execution', 'Commitments on offtake and financing agreements']
        },
        {
            id: 8,
            icon:step8Icon ,
            stepColor: "#51AC09",
            title: "Government Sponsors and Developer FID",
            description: "Government Sponsors and the Developer make their Financial Investment Decision (FID) after reviewing the Final Feasibility Studies"
        },
        {
            id: 9,
            icon:step9Icon,
            stepColor: "#4FB500",
            title: "Project Documents Signature and Financial Close",
            description: "All parties sign the binding project documents to reach financial close"
        }
    ]
    const [showMore, setShowMore] = useState({ id: null, show: false })
    return (
        <>
            <div className="process-Wrapper" id="process-summary">
                <div class="title-symbol production-capacity-symbol"><div class="page-symbole "></div><div class="title " >Process Summary</div></div>
                <div className="ctr">
                    <div className="process-cards">
                        <div className="row row-of-process">
                            {processSumary?.map(item => (
                                <div className={showMore.show && showMore.id == item.id ? "col-xl-4 col-lg-6 col-md-6 col-12 active-process-card-col":"col-lg-4 col-md-4 col-12 process-card-col"}
                                 key={item?.id}
                                 id={item?.id}
                                onClick={(e) => {
                                    const id = e.currentTarget.id
                                    id == null
                                      ? setShowMore({
                                          id,
                                          show: true,
                                        })
                                      : id == showMore.id
                                      ? setShowMore({
                                          id: null,
                                          show: false,
                                        })
                                      : setShowMore({
                                          id,
                                          show: true,
                                        })
                                  }}
                                >
                                    <div className="process-card-item">
                                        <div className="process-card-item-content">
                                            <div className="item-process-number" style={{ backgroundColor: `${item?.stepColor}` }}>
            
                                                    <div className={showMore?.show && item?.id == showMore?.id ? "active-step-item-number":"step-item-number"}  >
                                                    <span>{item?.id}</span>
                                                       <img src={item?.icon} />
                                                      
                                                    </div>
                                                    {/* {showMore?.show && showMore?.id == item?.id && <div class="active-step-symbol"></div>} */}
                                            </div>
                                            <div className="item-process-title">
                                                <div>{item?.title}</div>
                                                <div></div>
                                            </div>
                                        </div>
                                        <div className="card-arrow-wrapper">
                                            <div className="card-down-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="11" viewBox="0 0 20 11" fill="none">
                                                <path id="Vector 32" d="M0.645996 1L10.469 9L18.8887 1" stroke="#605D5E" stroke-opacity="0.63" stroke-width="2" />
                                            </svg></div>
                                        </div>
                                      
                                    </div>
                                    <div className="card-arrow-wrapper">
                                        <div className="card-symbol-svg"><svg xmlns="http://www.w3.org/2000/svg" width="6" height="25" viewBox="0 0 6 25" fill="none">
                                            <path id="Vector 31" d="M0.333334 22C0.333334 23.4728 1.52724 24.6667 3 24.6667C4.47276 24.6667 5.66667 23.4728 5.66667 22C5.66667 20.5272 4.47276 19.3333 3 19.3333C1.52724 19.3333 0.333334 20.5272 0.333334 22ZM2.5 2.18557e-08L2.5 22L3.5 22L3.5 -2.18557e-08L2.5 2.18557e-08Z" fill="black" />
                                        </svg></div>
                                    </div>

                                    {showMore.show && showMore.id == item.id  && <div className="process-card-desc" >
                                        <div className="content">{item?.description}</div>
                                        {item?.listContent?.length > 0 && <>
                                        <ul>
                                        {item?.listContent?.map((item,index) => (
                                            <li>
                                                {item}
                                            </li>
                                        ))}
                                        </ul>
                                        </>}

                                        <div className="card-up-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="11" viewBox="0 0 20 11" fill="none">
                                                <path id="Vector 32" d="M0.645996 1L10.469 9L18.8887 1" stroke="#605D5E" stroke-opacity="0.63" stroke-width="2" />
                                            </svg></div>
                                    </div>}
                                </div>
                            ))}
                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}
export default ProcessSummary